import { render } from "./TypeEditUsage.vue?vue&type=template&id=85890706"
import script from "./TypeEditUsage.vue?vue&type=script&lang=js"
export * from "./TypeEditUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__